module.exports = __webpack_public_path__ + "static/MT_Benefit-06.84545364.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-06.png
// module id = 1466
// module chunks = 169858455373905